/** Ключ диалога для сопоставления с WebSocket-событиями. */
export function dialogKey(dialog) {
  if (!dialog) return '';
  if (dialog.type === 'saved') return `saved_${dialog.id}`;
  return `${dialog.type}_${dialog.id}`;
}

export function sameId(a, b) {
  if (a == null || b == null) return false;
  return String(a) === String(b);
}

/** Определяем, к какому диалогу относится входящее сообщение. */
export function resolveDialogKeyFromMessage(message, myUserId) {
  if (!message) return '';
  if (message.channelId) return `channel_${message.channelId}`;
  if (message.groupId) return `group_${message.groupId}`;
  if (
    sameId(message.senderId, message.receiverId) &&
    sameId(message.senderId, myUserId)
  ) {
    return `saved_${myUserId}`;
  }
  const otherId = sameId(message.senderId, myUserId)
    ? message.receiverId
    : message.senderId;
  return `user_${otherId}`;
}

export function messagePreview(message) {
  const type = message.messageType || message.message_type || 'text';
  if (type === 'image') return '📷 Фото';
  if (type === 'card') return '📌 Карточка';
  if (type === 'audio') return '🎵 Голосовое';
  if (type === 'sticker') return '🎨 Стикер';
  const text = message.content ?? message.text ?? '';
  return typeof text === 'string' ? text.substring(0, 200) : '';
}

export function sortDialogs(dialogs) {
  const saved = dialogs.filter((d) => d.type === 'saved');
  const rest = dialogs.filter((d) => d.type !== 'saved');
  rest.sort((a, b) => {
    const ta = a.lastMessageTime ? new Date(a.lastMessageTime).getTime() : 0;
    const tb = b.lastMessageTime ? new Date(b.lastMessageTime).getTime() : 0;
    return tb - ta;
  });
  return [...saved, ...rest];
}

/**
 * Инкрементальное обновление списка диалогов при новом сообщении (без refetch API).
 * @returns {{ dialogs: object[], needsSync: boolean }}
 */
export function applyMessageToDialogs(dialogs, message, { activeDialogKey, myUserId }) {
  const key = resolveDialogKeyFromMessage(message, myUserId);
  if (!key) return { dialogs, needsSync: false };

  const isOwn = sameId(message.senderId, myUserId);
  const isActive = activeDialogKey === key;
  const time = message.createdAt || message.created_at || new Date().toISOString();
  const preview = messagePreview(message);
  const msgType = message.messageType || message.message_type || 'text';

  let found = false;
  const updated = dialogs.map((d) => {
    if (dialogKey(d) !== key) return d;
    found = true;
    return {
      ...d,
      lastMessage: preview,
      lastMessageType: msgType,
      lastMessageTime: time,
      unreadCount: isActive || isOwn
        ? 0
        : (d.unreadCount || 0) + 1,
    };
  });

  if (!found) {
    return { dialogs, needsSync: true };
  }

  return { dialogs: sortDialogs(updated), needsSync: false };
}

export function computeUnreadTotal(dialogs) {
  return (dialogs || []).reduce((sum, d) => sum + (d.unreadCount || 0), 0);
}
